import React from 'react';
import '../Style/components.css';
export default function Information(props) {
  return (
    <div
      style={props.show ? { display: 'block' } : { display: 'none' }}
      className="menu"
    >
      <div className="close" onClick={() => props.toggle(null)}>
        <i className="fi-rr-cross"></i>
      </div>
      <h3 className="head_text">Information</h3>
      <div className="info_message">
        {props.data ? props.data.message : null}
      </div>
      <div className="info_body">
        {props.data
          ? props.data.links.map((link, i) => (
              <div
                onClick={() => window.open(link.url)}
                className="info_icons"
                title={link.name}
                key={i}
              >
                {link.icon}
              </div>
            ))
          : null}
      </div>
    </div>
  );
}
